// Styles
import "./assets/scss/index.scss";

import { initRazorComponents } from "@sitebuilder/razor/index.js";
import { initRazorFormValidation } from "@sitebuilder/razor/razorForm.js";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

const connection = new HubConnectionBuilder().withUrl("/placeHub").configureLogging(LogLevel.Information).build();

const blockProducts = (items) => {
  items.forEach((item) => {
    const place = document.getElementById("place-" + item);
    if (place) {
      place.classList.add("registered");
    }
  })
};

const orderedItems = [];

connection.on("BlockItems", blockProducts);
connection.on("OrderedItem", (data) => setTimeout(() => {orderedItems.push(data); blockProduct(data); }, 500));

connection.on("ReleaseItems", (items) => {
    console.log("ReleaseItems !!!!!!!!!!",  items);
  
    items.forEach((item) => {
      const place = document.getElementById("place-" + item);
      if (place && !orderedItems.includes(place)) {
        place.classList.remove("registered");
      }
    })
});

function start() {
  return connection.start().catch((err) => {
    console.error("Failed to connect with hub. Retry in 5s.", err);
    return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000));
  });
}
connection.onclose(() => start());
start();

// connection.start().then(() => connection.invoke("send", "Hello"));

console.log("connection", connection);

window.consent = (val) => {
  fetch("/consent", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(val),
  })
    .then((resp) => resp.json())
    .then((data) => console.log(data))
    .catch(function (error) {
      console.log("Request failed", error);
    })
    .finally(() => document.getElementById("cookieConsent").remove());
};

window.addEventListener("DOMContentLoaded", () => {
  initRazorComponents(window);
  initRazorFormValidation(window);
  console.log("init tenant website");
});
